import React from 'react'
import './css/BracketColumn.css'
import Game from './game';

function BracketColumn(props){
    const games_count = props.games.length
    console.log(games_count)
    const game_height = {
        height: 1000/games_count
    }
    const title_height = {
        height: 20
    }
    return(
        <div className="bracketcolumn">
            <div style={title_height}>
                <b>{props.division}</b>
            </div>
            <div className="bracket-table">
                {props.games.map((game, index) => {
                    return (
                        <div style={game_height}>
                            <div className='external'>
                                <div className='middle'>
                                    <div className="internal">
                                        <Game game={game} height={1000 / (games_count)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
                </div>
        </div>
    )
}

export default BracketColumn;